export class EnaioAddonCounterRegisterFields {
    registerName = "";
    fields: string[];
}
